// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#phoneCodes .p-dropdown-trigger{width:1.75rem}#phoneCodes .p-dropdown-label.p-inputtext{padding-left:4px;padding-right:4px;text-align:center}.location-message .p-message-text{width:100%;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
